import tailwindConfig from './tailwind.config';

//https://nuxt.com/docs/guide/directory-structure/app-config
export default defineAppConfig({
    extends: ['../_base'],
    tailwindCss: {
        config: tailwindConfig,
    },
});
